<template>
  <div class="not_allow">
    <div class="text">
      <img src="../assets/redirect/arrow.png" class="arrow">
      <div>下载就差一步啦！</div>
      <div>请点击<span class="red">右上角...</span></div>
      <div>选择<span class="red">“在浏览器中打开”</span></div>
    </div>
    <img src="../assets/redirect/demo.png" class="demo">
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>

.not_allow {
  position: fixed;
  top: 0;
  left: 0;
  background-color: #f8f8f8;
  width: 100vw;
  height: 100vh;
  img.demo {
    width: 699px;
    height: 699px;
    position: absolute;
    bottom: 175px;
    left: 50%;
    transform: translateX(-50%);
  }
  .text {
    position: absolute;
    bottom: 974px;
    left: 50%;
    transform: translateX(-50%);
    white-space: nowrap;
    font-size: 36px;
    font-weight: bold;
    color: #3f3f3e;
    img.arrow {
      position: absolute;
      right: 0;
      top: 0;
      width: 153px;
      height: 104px;
      transform: translate(75px,-90px);
    }
    > div {
      margin-top: 10px;
    }
    .red {
      color: #db1818;
    }
  }
}
</style>
